/**
 * Icons for the mobile tab bar.
 *
 * The web app has no icon library, so these are inline paths in the same shape as the star
 * in `favourite-button.tsx`. The path data is lifted from the MaterialIcons glyphs the
 * native tabs already use (`apps/mobile/app/(tabs)/_layout.tsx`), so the two navigations
 * read as the same product rather than two takes on it.
 */

const PATHS = {
  recipes:
    'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4',
  favourites:
    'M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z',
  schedule:
    'M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z',
  more: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2',
  plus: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z',
} as const;

export type NavIconName = keyof typeof PATHS;

/** Decorative by default: every caller pairs the glyph with a visible or assistive label. */
export function NavIcon({
  name,
  className = 'tabbar-icon',
}: {
  name: NavIconName;
  className?: string;
}) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d={PATHS[name]} fill="currentColor" />
    </svg>
  );
}
